import { View } from "@/components/ui/view";
import { Textarea, TextareaInput } from "@/components/ui/textarea";
import { Text } from "@/components/ui/text";
import React, { useState, useEffect } from 'react';

const textHeights = [ 'h-[48px]', 'h-[64px]', 'h-[80px]', 'h-[96px]', 'h-[112px]', 'h-[128px]' ];

export default function ChangeableText({ text, updateText, disabled, placeholder, fontSize, fontWeight, colorInverted, mx }) {
    const [inputHeight, setInputHeight] = useState(0)
    const [cnt, setCnt] = useState(0)
    const [localText, setLocalText] = useState(text)

    const changeText = (newText) => {
        setLocalText(newText)
        updateText(newText)
    }

    useEffect(() => {
        if (text != localText) {
            setLocalText(text)
        }
    }, [text])

    return (disabled ? <View className={` ${colorInverted ? "border-b-primary-900" : "border-b-primary-50"} flex-1 p-2 `}>
        <Text className={` ${colorInverted ? "text-secondary-50" : "text-secondary-900"} ${fontWeight} ${fontSize || 'text-md'} `}>
            {localText}
        </Text>
    </View> : <Textarea size="lg" dataSet={{ nodrag: 1 }} className={` ${textHeights[inputHeight]} ${colorInverted ? "border-primary-900" : "border-primary-50"} flex-1 max-h-[200px]`}>
        <TextareaInput
            maxLength={1000}
            value={localText}
            placeholder={placeholder}
            onContentSizeChange={(event) => {
                const h = Math.min(textHeights.length - 1, Math.floor((event.nativeEvent.contentSize.height - 46) / 16))
                // console.log('CSC', cnt, text.length, h) 
                if (cnt < 48) {
                    // this events seems to be triggered repeatedly in small increments
                    setInputHeight(h)
                } else {
                    if (text.length < 20) {
                        setInputHeight(0)
                    }
                }
                setCnt(cnt + 1)
            }}
            onChange={(event) => {
                // console.log('CSC', event.nativeEvent.inputType)
                changeText(event.nativeEvent.text)
                setCnt(0)
            }}
            selectionColor='#D2D4D7'
            className={` ${colorInverted ? 'placeholder:text-secondary-300 web:text-secondary-50' : 'placeholder:text-secondary-400 web:text-secondary-900'} ${fontWeight} ${fontSize || 'text-md'} `} />
    </Textarea>);
}
